<section>
    <div class="container text-center text-lg-start">
        <img class="content-points" src="assets/icons/element-graphique-point.svg" />

        <div class="row content">

          <div class="col-lg-8">
            <h2 class="asso-title">{{asso.nom}}</h2>

            <img class="img-fluid"  src="{{asso.vignette}}"  />

            <div class="contact-container mt-3">
                <div *ngIf="asso.adresse" class="adress text-justify">
                    {{asso.adresse}}
                </div>
                <a *ngIf="asso.phone" class="link" href="tel:{{asso.phone}}">
                  <div class="phone text-center">{{asso.phone}}</div>
                </a>

                <div class="web mt-3">
                    <a *ngIf="asso.site" class="link" href="{{asso.site}}">
                      <div class="info">Site</div>
                    </a>
                    <a *ngIf="asso.mail" class="link" href="mailto:{{asso.mail}}">
                      <div class="info">Courriel</div>
                    </a>
                </div>
            </div>
            <div class="informations mt-3">
                <div *ngIf="asso.referent" class="referent mt-3">
                    <b>Personne référente: {{asso.referent}}</b>
                </div>
                <div *ngIf="asso.autreContact" class="autre mt-3">
                    <b>Autre contact: {{asso.autreContact}}</b>
                </div>

                <div *ngIf="asso.horaires" class="mt-3">
                    <b class="mt-3">Horaires :</b>
                    <div [innerHTML]="asso.horaires">
                    </div>
                </div>

                <div *ngIf="asso.description" class="mt-3">
                    <b class="mt-3">Informations :</b>
                    <div [innerHTML]="asso.description">
                    </div>
                </div>
            </div>
        </div>

          <div class="col-lg-4">
            <app-quick-access></app-quick-access>
          </div>

        </div>
      </div>
</section>
